/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useIntl} from 'react-intl'
import {KTIcon} from 'src/_metronic/helpers'
import {PageTitle} from 'src/_metronic/layout/core'
import {CardNav} from 'src/app/helpers/components/cards/CardNav'
import {
  CardsIconBasic,
} from '../../partials/widgets'
import { Navigate, Link } from 'react-router-dom'

const AdministrationPage: FC = () => {
  const intl = useIntl()
  return (
    <>
      {/* begin::Row */}
      <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
        <div className='col-12'>
          <div className='card shadow-sm'>
            <div className='card-body bg-light rounded pb-0'>
              <div className='row'>
                <div className='col-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3 mb-md-5 mb-xl-10 h-100'>
                  <CardNav
                    to='./department'
                    kticon='data'
                    title={intl.formatMessage({
                      id: 'MENU.ADMINISTRATION.DEPARTMENT',
                    })}
                  />
                </div>
                <div className='col-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3 mb-md-5 mb-xl-10 h-100'>
                  <CardNav
                    to='./position'
                    kticon='compass'
                    title={intl.formatMessage({
                      id: 'MENU.ADMINISTRATION.POSITION',
                    })}
                  />
                </div>
                <div className='col-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3 mb-md-5 mb-xl-10 h-100'>
                  <CardNav
                    to='./user'
                    kticon='profile-user'
                    title={intl.formatMessage({
                      id: 'MENU.ADMINISTRATION.USER',
                    })}
                  />
                </div>
                <div className='col-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3 mb-md-5 mb-xl-10 h-100'>
                  <CardNav
                    to='./access'
                    kticon='data'
                    title={intl.formatMessage({
                      id: 'MENU.ADMINISTRATION.ACCESS',
                    })}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* end::Row */}
    </>
  )
}

const AdministrationWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle>{intl.formatMessage({id: 'MENU.ADMINISTRATION'})}</PageTitle>
      <AdministrationPage />
    </>
  )
}

export {AdministrationWrapper}
